<template>
    <div class="global-message flex flex--align-center">
      <v-icon type="iconnotification_important-24px" size="40"></v-icon>
      <div class="global-message__list-wrapper">
        <ul :class="messageListClasses"
            @click="handleShowMessageList"
            :style="{transform: `translateY(${-index * 58}px)`}">
          <li v-for="(msg, idx) in messageList" 
            :key="idx"
            :class="index === idx ? '' : 'hidden'">
            <h2 class="title">{{msg.subject}}</h2>
            <div class="content">{{msg.content}}</div>
          </li>
        </ul>
      </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'globalMessage',
  data() {
    return {
      index: 0,
      timer: null,
      isListTransition: true,
    };
  },
  computed: {
    ...mapState(['messageListVisible']),
    ...mapState('message', {
      messageList: 'messageOnDashboard'
    }),
    messageListClasses() {
      const classes = ['global-message__list'];
      if (this.isListTransition) {
        classes.push('transition');
      }
      return classes;
    },
  },
  mounted() {
    this.switchShowList();
  },
  methods: {
    ...mapMutations(['updateState']),
    switchShowList() {
      this.timer = setInterval(() => {
        this.index += 1;
        this.isListTransition = true;
        this.$nextTick(() => {
          if (this.index >= this.messageList.length) {
            setTimeout(() => {
              this.isListTransition = false;
              this.index = 0;
            }, 550);
          }
        });
      }, 5000);
    },
    handleShowMessageList() {
      this.updateState({
        messageListVisible: true,
      });
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style lang="less">
  @prefix: ~'global-message';

  .@{prefix} {
    width: 1008px;
    margin: 0 auto 8px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .1),
    0 3px 4px 0 rgba(0, 0, 0, .08),
    0 1px 5px 0 rgba(0, 0, 0, .16);
    padding: 16px;
    height: 90px;
    overflow: hidden;
    .v-icon{
      color: rgb(255, 152, 0);
    }
    &__list-wrapper{
      overflow: hidden;
      height: 100%;
    }
    &__list{
      padding-left: 16px;
      &.transition{
        transition: transform .5s;
        li{
          transition: opacity .5s;
        }
      }
      li{
        opacity: 1;
        cursor: pointer;
        &.hidden{
          opacity: 0;
        }
        .title{
          font-size: 14px;
          color: rgba(0, 0, 0, 0.54);
          line-height: 20px;
          font-weight: 700;
        }
        .content{
          margin-top: 2px;
          color: rgba(0, 0, 0, 0.54);
          line-height: 18px;
          height: 36px;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
</style>
